import dialogConfig, { AlmeDialogConfig, DialogConfig } from "../../AlmeDialog/AlmeDialogConfig";
import { InlineSurveyLinkAppEventConfig } from "./AlmeSurvey";

export type RadioButtonColor = 'default' | 'primary' | 'secondary' | undefined;

interface SurveyConfig extends DialogConfig {
    freeformTextMaxLength?: number;
    radioButtonColor?: RadioButtonColor;
    radioButtonOptions?: string[];
    submitLinkConfig?: InlineSurveyLinkAppEventConfig;
}

interface AlmeSurveyDialogConfig extends AlmeDialogConfig {
    dialog: SurveyConfig;
}

export interface AlmeSurveyConfig {
    survey: AlmeSurveyDialogConfig;
}

/**
 * This is the baseline survey config. Some values from this config will be populated via response action.
 * @summary
 * ! Important do not edit this config with client customizations!
 * Custom client config changes should be made in src/personas/config/appConfigMain
 * @see appConfigMain
*/
const defaultConfig: AlmeSurveyConfig = {
    survey: {
        dialog: {
            ...dialogConfig.dialog,
        },
    },
};

export default defaultConfig;
